import axios from 'axios';
import ENV from './environment';

const BASE_URL = ENV.apiURL;
const Axios = axios.create({
    baseURL: BASE_URL,
});

// Add a response interceptor for global error reporting
Axios.interceptors.response.use(
    (response) => response,
    (error) => {
        // Only report if it's a server error or unexpected error
        // Don't report 401 (Unauthorized) or 404 (Not Found) if they are handled locally
        if (error.response && error.response.status >= 500) {
            import('./errorReporting').then(({ default: reportError }) => {
                reportError({
                    error: {
                        message: `API Error: ${error.response.status} ${error.config.method.toUpperCase()} ${error.config.url}`,
                        status: error.response.status,
                        data: error.response.data
                    },
                    context: { type: 'api_error_5xx' }
                });
            });
        }
        return Promise.reject(error);
    }
);

export default Axios;
